import React, { Component } from 'react'

import config from './config.js'

import axios from 'axios'

import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch
} from 'react-router-dom'

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles'

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  TextField
} from '@material-ui/core/'

import AppLogo from './Components/AppLogo'
import AppLogoNoText from "./Components/AppLogoNoText";
import AppMenu from './Components/AppMenu'
import JoinNow from './Components/JoinNow'
import LoadingIcon from './Components/LoadingIcon'
import MyFriends from './Components/MyFriends'
import MyLibrary from './Components/MyLibrary'
import PublishedRecipes from './Components/PublishedRecipes'
import Recipe from './Components/Recipe'
import ScrollHandler from './Components/ScrollHandler'
import SystemMessageSnackbar from './Components/SystemMessageSnackbar'
import ToolbarBackButton from './Components/ToolbarBackButton'
import UserArea from './Components/UserArea'

import { setCookie, getCookie, deleteCookie } from './Helpers/cookies'
import { logCurrentUsage, logDailyUsage } from './Helpers/logging'
import { getQueryVariable } from './Helpers/urls'

import './App.css'
import ConsoleLogViewer from "./Components/ConsoleLogViewer";
import Login from "./Components/Login";
import Settings from "./Components/Settings";

class App extends Component {
  constructor(props) {
    super(props)

    let device = ''
    let theme = 'light'
    let version = ''
    let test = ''

    let sid = undefined

    const currentUrl = window.location.href

    // When we're first bootstrapping the app, check to see if there is a session ID--if there is, we can log the user in automatically
    if (currentUrl !== undefined && currentUrl !== '') {
      // This is the new way of checking for a session ID. Any URL can include one as a query string parameter and thereby log in automatically
      if (
        window.location.search !== undefined &&
        window.location.search !== ''
      ) {
        device = getQueryVariable('device', window.location.search)
        if (device === undefined || device === false) {
          // The query string was not found, so we'll default to web
          device = 'web'
        }

        theme = getQueryVariable('thm', window.location.search)
        if (theme === 'dark') {
          // If these manual overrides become unmanageable, we can create a dark theme object in the config file and
          // Overwrite the base theme object
          config.theme.palette.type = 'dark'
          config.theme.palette.primary.main = '#0b8fdd'
          config.theme.palette.primary.light = '#2bafff'
          config.theme.palette.primary.dark = '#006fbd'
          config.theme.palette.text.primary = '#efefef'
          config.theme.palette.text.secondary = '#808080'

          document.body.style.backgroundColor = '#000'
        }

        version = getQueryVariable('ver', window.location.search)

        test = getQueryVariable('test', window.location.search)

        sid = getQueryVariable('sid', window.location.search)

        if (sid !== false) {
          this.loginEmbedHandler(sid)
        }

        // Add query params to window so that they are globally available
        window.queryParams = {
          device: device,
          theme: theme,
          version: version,
          test: test
        }
      } else {
        // Set empty object for queryParams so that calls like window.queryParams.someParam result in undefined rather
        // than an exception
        window.queryParams = {}
      }

      // This is the old way of checking for the session ID, when it was a URL segment rather than a query string parameter.
      // We have to keep this around for a while.
      if (
        (sid === undefined || sid === false) &&
        currentUrl.indexOf('sid/') !== -1
      ) {
        let segments = currentUrl.split('/')

        for (let i = 0; i <= segments.length - 1; i++) {
          if (segments[i] === 'sid') {
            sid = segments[i + 1].split('?')[0]
            this.loginEmbedHandler(sid)
          }
        }
      }
    }

    this.state = {
      isLoaded: false,
      userLoggedIn: false,
      continueUrl: '',
      device: device,
      theme: theme,
      version: version,
      test: test,

      userEmail: null,
      userPassword: null,

      sessionId: undefined,
      accountId: undefined,

      userName: undefined,
      userNameDisplay: undefined,
      userAvatar: undefined,
      userPhoneNumber: undefined,

      recipeEmbedded: [],

      systemMessage: {}
      //debugging: ''
    }
  }

  callingAjax = false
  currentlyCheckingLogin = false
  embedSessionId = ''

  createAccountHandler = () => {
    window.open('https://www.dvo.com/sign-up.php')
  }

  loginFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  loginEmbedHandler = sessionId => {
    this.embedSessionId = sessionId // Set this as quickly as possible

    // Because we are loading an embedded session, we need to delete any cookies that were previously set
    deleteCookie('sessionId')
    deleteCookie('accountId')
    deleteCookie('userName')
    deleteCookie('userNameDisplay')
    deleteCookie('userAvatar')
    deleteCookie('userPhoneNumber')

    // this.setState((state, props) => ({
    //   debugging:
    //     this.state.debugging +
    //     'Global embedSessionId: ' +
    //     this.embedSessionId +
    //     ' '
    // }))
    this.loginCheck()
  }

  forgotPassword = () => {
    if (this.state.userEmail) {
      const email = encodeURIComponent(this.state.userEmail)

      axios
        .get(
          config.apiServer +
            '/api/v2/account/web/send-change-pword/d?eml=' +
            email,
          {}
        )
        .then(
          response => {
            const json = response.data
            // console.log("Change password response: [" + JSON.stringify(json) + "]");

            if (json.messageKey === 'CHANGE_PASSWORD_EMAIL_SENT') {
              this.setState({
                systemMessage: {
                  message:
                    'Password reset link sent. Please check your e-mail.',
                  type: 'success',
                  duration: 6000,
                  timestamp: new Date().getTime()
                }
              })
            } else if (json.messageKey === 'ACCOUNT_NOT_FOUND_FOR_EMAIL') {
              this.setState({
                systemMessage: {
                  message:
                    'Account not found for email address provided. Password reset link not sent.',
                  type: 'error',
                  duration: 9000,
                  timestamp: new Date().getTime()
                }
              })
            } else {
              this.setState({
                systemMessage: {
                  message:
                    'There was an error resetting your password. Please try again later.',
                  type: 'error',
                  duration: 9000,
                  timestamp: new Date().getTime()
                }
              })
            }
          },
          error => {
            this.setState({
              systemMessage: {
                message:
                  'There was an error resetting your password. Please try again later.',
                type: 'error',
                duration: 9000,
                timestamp: new Date().getTime()
              }
            })
          }
        )
    } else {
      this.setState({
        systemMessage: {
          message: 'Please enter an email address to reset.',
          type: 'error',
          duration: 9000,
          timestamp: new Date().getTime()
        }
      })
    }
  }

  login = e => {
    e.preventDefault()

    let data = JSON.stringify({
      email: this.state.userEmail,
      password: this.state.userPassword
    })

    axios
      .post(config.apiServer + '/api/v3/web/login', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          const json = response.data
          // console.log("Login response: [" + JSON.stringify(json) + "]");

          if (json.key === 'OK') {
            const loginValid = json.result.valid
            const loginMembershipStatus = json.result.membershipStatus

            if (loginValid !== false) {
              if (loginMembershipStatus !== null) {
                this.setState({
                  isLoaded: true,
                  userLoggedIn: true,
                  sessionId: json.result.sessionId,
                  accountId: json.result.accountId,
                  userName: json.result.userName,
                  userNameDisplay: json.result.displayName,
                  userAvatar: json.result.avatarUrl
                })

                this.logUsage(json.result.sessionId)

                // Set cookies so that the user can stay logged in more easily
                setCookie('sessionId', this.state.sessionId, 30)
                setCookie('accountId', this.state.accountId, 30)
                setCookie('userName', this.state.userName, 30)
                setCookie('userNameDisplay', this.state.userNameDisplay, 30)
                setCookie('userAvatar', this.state.userAvatar, 30)
              } else {
                this.setState({
                  systemMessage: {
                    message:
                      "A Cook'n Membership is required to log in. Please sign up! You will be redirected in 10 seconds.",
                    type: 'warning',
                    duration: 9000,
                    timestamp: new Date().getTime()
                  }
                })
                setTimeout(function() {
                  window.location.href = '/cooking-club.php'
                }, 10000)
              }
            } else {
              this.setState({
                systemMessage: {
                  message: 'Invalid email or password, please try again.',
                  type: 'error',
                  duration: 6000,
                  timestamp: new Date().getTime()
                }
              })
            }
          } else {
            if (json.key === 'ACCOUNT_NOT_ACTIVATED') {
              this.setState({
                systemMessage: {
                  message:
                    'Your account needs to be activated. Please see your account activation email.',
                  type: 'warning',
                  duration: 9000,
                  timestamp: new Date().getTime()
                }
              })
            }
          }
        },
        error => {
          if (error.response) {
            const json = error.response.data
            // console.log("Login error response: [" + JSON.stringify(json) + "]");

            const key = json.key
            let message = json.message
            if (!message) {
              message = 'Invalid email or password, please try again.'
            }
            this.setState({
              systemMessage: {
                message: message,
                type: 'error',
                duration: 6000,
                timestamp: new Date().getTime()
              }
            })
          } else {
            this.setState({
              systemMessage: {
                message:
                  'There was an error while trying to log you in, please try again later.',
                type: 'error',
                duration: 9000,
                timestamp: new Date().getTime()
              }
            })
          }
        }
      )
  }

  loginCheck = () => {
    const embedSessionId = this.embedSessionId
    const cookieSessionId = getCookie('sessionId')

    let checkSessionId = ''

    if (embedSessionId !== '' || cookieSessionId !== '') {
      if (embedSessionId !== '') {
        checkSessionId = embedSessionId
      } else if (cookieSessionId !== '') {
        checkSessionId = cookieSessionId
      }
      if (checkSessionId !== '' && this.currentlyCheckingLogin === false) {
        this.currentlyCheckingLogin = true
        axios
          .get(
            config.apiServer + '/api/v3/web/validate?sid=' + checkSessionId,
            {}
          )
          .then(
            response => {
              this.currentlyCheckingLogin = false

              const json = response.data

              // this.setState((state, props) => ({
              //   debugging:
              //     this.state.debugging +
              //     window.location.href +
              //     ' ' +
              //     'checkSessionId: ' +
              //     checkSessionId +
              //     ' ' +
              //     'embedSessionId: ' +
              //     embedSessionId +
              //     ' ' +
              //     'cookieSessionId: ' +
              //     cookieSessionId +
              //     ' ' +
              //     'loginCheck results: ' +
              //     JSON.stringify(json) +
              //     ' '
              // }))

              if (json.key === 'OK') {
                const loginValid = json.result.valid
                const loginMembershipStatus = json.result.membershipStatus

                if (loginValid !== false && loginMembershipStatus !== null) {
                  this.setState({
                    isLoaded: true,
                    userLoggedIn: true,
                    sessionId: checkSessionId,
                    accountId: json.result.accountId,
                    userName: json.result.userName,
                    userNameDisplay: json.result.displayName,
                    userAvatar: json.result.avatarUrl,
                    userPhoneNumber: json.result.phoneNumber
                  })
                  this.logUsage(checkSessionId)

                  // Re-set cookies so that the user can stay logged in more easily
                  setCookie('sessionId', this.state.sessionId, 30)
                  setCookie('accountId', this.state.accountId, 30)
                  setCookie('userName', this.state.userName, 30)
                  setCookie('userNameDisplay', this.state.userNameDisplay, 30)
                  setCookie('userAvatar', this.state.userAvatar, 30)
                  setCookie('userPhoneNumber', this.state.userPhoneNumber, 30)
                } else {
                  this.setState({
                    isLoaded: true,
                    userLoggedIn: false
                  })
                }
              }
            },
            error => {
              this.currentlyCheckingLogin = false

              // this.setState((state, props) => ({
              //   debugging: this.state.debugging + error
              // }))
              console.log(error)

              this.setState({
                isLoaded: true,
                userLoggedIn: false
              })
            }
          )
      }
    } else if (embedSessionId === '' && cookieSessionId === '') {
      this.setState({
        isLoaded: true,
        userLoggedIn: false
      })
    }
  }

  logout = () => {
    let data = JSON.stringify({
      sessionId: this.state.sessionId
    })

    axios
      .post(config.apiServer + '/api/v3/web/logout', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          // Delete the cookies we set
          deleteCookie('sessionId')
          deleteCookie('accountId')
          deleteCookie('userName')
          deleteCookie('userNameDisplay')
          deleteCookie('userAvatar')
          deleteCookie('userPhoneNumber')

          // Redirect to the home page
          window.location.href = '/'
        },
        error => {
          // this.setState((state, props) => ({
          //   debugging: this.state.debugging + error
          // }))
          console.log(error)
        }
      )
  }

  logUsage = sessionId => {
    logCurrentUsage(sessionId)
    logDailyUsage(sessionId)
  }

  getRecipeEmbedded = recipeId => {
    let recipe = undefined

    if (this.state.recipeEmbedded === null) {
      recipe = null
    } else if (
      this.state.recipeEmbedded === [] ||
      this.state.recipeEmbedded.length <= 0 ||
      this.state.recipeEmbedded.uuid !== recipeId
    ) {
      this.apiGetRecipeEmbedded(recipeId)
    } else {
      recipe = this.state.recipeEmbedded
    }

    return recipe
  }

  apiGetRecipeEmbedded = recipeId => {
    if (this.callingAjax === false) {
      this.callingAjax = true // We need to set this immediately to stop dozens of AJAX calls being made

      axios
        .get(
          config.apiServer +
            '/api/v3/web/recipe?sid=' +
            this.state.sessionId +
            '&rid=' +
            recipeId,
          {}
        )
        .then(
          response => {
            this.callingAjax = false

            const recipeJson = response.data.result

            if (recipeJson && recipeJson.recipe) {
              this.setState((state, props) => ({
                recipeEmbedded: recipeJson.recipe
              }))
            } else {
              this.setState((state, props) => ({
                recipeEmbedded: null
              }))
            }
          },
          error => {
            this.callingAjax = false

            // this.setState((state, props) => ({
            //   debugging: this.state.debugging + error
            // }))
            console.log(error)
          }
        )
    }
  }

  componentDidMount() {
    this.loginCheck()

    let continueUrl = undefined

    if (window.location.search !== undefined && window.location.search !== '') {
      continueUrl = getQueryVariable('continue', window.location.search)
    }

    if (continueUrl === undefined || continueUrl === false) {
      // The continueUrl was not found
      continueUrl = ''
    }

    this.setState((state, props) => ({
      continueUrl: continueUrl
    }))
  }

  componentDidUpdate() {
    // The code for checking the contineUrl is tricky because we have to simultaneously
    // 1. make sure it gets set (often the constructor or componentDidMount aren't catching it) and
    // 2. make sure it doesn't trigger a redirect over and over
    let continueUrl = undefined

    if (window.location.search !== undefined && window.location.search !== '') {
      continueUrl = getQueryVariable('continue', window.location.search)
    }

    // Because there isn't a continueUrl query string parameter, we need to make sure the app state also doesn't have one
    if (
      (continueUrl === undefined || continueUrl === false) &&
      this.state.continueUrl !== ''
    ) {
      this.setState((state, props) => ({
        continueUrl: ''
      }))
    }
    // If we have a continueUrl that isn't empty and it isn't the same as the one in the app state, then we need to update it
    else if (
      continueUrl !== undefined &&
      continueUrl !== false &&
      continueUrl !== this.state.continueUrl
    ) {
      this.setState((state, props) => ({
        continueUrl: continueUrl
      }))
    }
    // If we get past the two elses without updating the app state,
    // it's because we have a continueUrl query string parameter and it's the same as the one in the app state, thus requiring no update
  }

  render() {
    const {
      isLoaded,
      userLoggedIn,
      continueUrl,

      sessionId,
      accountId,
      device,
      theme,
      version,

      userName,
      userNameDisplay,
      userAvatar,

      systemMessage
      //debugging
    } = this.state

    const { classes } = this.props

    if (!isLoaded) {
      return (
        <div id="app-container" className={'theme--' + theme}>
          <Grid container spacing={24}>
            <Grid item xs />
            <Grid item xs={10} sm={6} md={4}>
              <div style={{ padding: '20px', textAlign: 'center' }}>
                <LoadingIcon />
              </div>
            </Grid>
            <Grid item xs />
          </Grid>
        </div>
      )
    } else if (!userLoggedIn) {
      return (
        <Router>
          <ScrollHandler>
            <Switch>
              <Route
                exact
                path={config.baseUrl + '/'}
                render={() => <Redirect to={config.baseUrl + '/login'} />}
              />
              <Route
                exact
                path={config.baseUrl + '/login'}
                render={({ match }) => (
                  <div
                    id="app-container"
                    className={'login theme--' + theme}
                    style={{ paddingTop: '0' }}
                  >
                    <Login
                        theme={config.theme}
                        login={this.login}
                        loginFormChangeHandler={this.loginFormChangeHandler}
                        forgotPassword={this.forgotPassword}
                        createAccountHandler={this.createAccountHandler}
                    />
                    <SystemMessageSnackbar systemMessage={this.state.systemMessage} />
                  </div>
                )}
              />

              <Route
                path={config.baseUrl + '/embed/friends/sid/:sessionId'}
                render={({ match }) => {
                  return (
                    <div id="app-container-embed" className={'theme--' + theme}>
                      <Grid container spacing={24}>
                        <Grid item xs />
                        <Grid item xs={10} sm={6} md={4}>
                          <div style={{ padding: '20px', textAlign: 'center' }}>
                            <LoadingIcon />
                          </div>
                        </Grid>
                        <Grid item xs />
                      </Grid>
                    </div>
                  )
                }}
              />
              <Route
                path={config.baseUrl + '/embed'}
                render={({ match }) => (
                  <div id="app-container-embed" className={'theme--' + theme}>
                    <h2 className="text-center" style={{ padding: '20px' }}>
                      Friends Not Loaded
                    </h2>
                  </div>
                )}
              />

              <Route
                path={config.baseUrl + '/recipes/:recipeId'}
                render={({ match }) => (
                  <Redirect
                    to={config.baseUrl + '/login' + '?continue=' + match.url}
                  />
                )}
              />

              <Route
                path={config.baseUrl + '/:userName/cookbooks'}
                render={({ match }) => (
                  <div
                    id="app-container--published-recipes-logged-out"
                    className={'theme--' + theme}
                  >
                    <div id="app-tools--published-recipes-logged-out">
                      <AppLogoNoText />
                      <JoinNow />
                    </div>
                    <PublishedRecipes
                      match={match}
                      theme={theme}
                      userName={match.params.userName}
                    />
                  </div>
                )}
              />

              <Route
                exact
                path={config.baseUrl + '/:userName/friends*'}
                render={({ match }) => (
                  <Redirect
                    to={config.baseUrl + '/login' + '?continue=' + match.url}
                  />
                )}
              />

              <Route
                exact
                path={config.baseUrl + '/:userName/settings'}
                render={({ match }) => (
                  <Redirect
                    to={config.baseUrl + '/login' + '?continue=' + match.url}
                  />
                )}
              />

              <Route
                exact
                path={config.baseUrl + '/:userName'}
                render={({ match }) => (
                  <Redirect
                    to={
                      config.baseUrl +
                      '/' +
                      match.params.userName +
                      '/cookbooks'
                    }
                  />
                )}
              />
            </Switch>
          </ScrollHandler>
        </Router>
      )
    } else if (continueUrl !== undefined && continueUrl !== '') {
      // We are not using the config.baseUrl here because the match.url used above makes it part of the continueUrl here
      return (
        <Router>
          <Route
            path={config.baseUrl + '/login'}
            render={() => <Redirect to={continueUrl} />}
          />
        </Router>
      )
    } else {
      // Create a log viewer element when "test" param is true
      let consoleLogViewer = ""
      if (window.queryParams.test) {
        consoleLogViewer = (<ConsoleLogViewer/>)
      }

      return (
        <MuiThemeProvider theme={config.theme}>
          <Router>
            <Switch>

              <Route
                exact
                path={config.baseUrl + '/'}
                render={() => (
                  <Redirect
                    to={config.baseUrl + '/' + userName + '/cookbooks'}
                  />
                )}
              />
              <Route
                exact
                path={config.baseUrl + '/login'}
                render={() => (
                  <Redirect
                    to={config.baseUrl + '/' + userName + '/cookbooks'}
                  />
                )}
              />

              <Route
                path={config.baseUrl + '/embed/friends/sid/:sessionId'}
                render={({ match }) => (
                  <Redirect to={config.baseUrl + '/embed/friends'} />
                )}
              />
              <Route
                path={config.baseUrl + '/embed/friends'}
                render={({ match }) => (
                  <div id="app-container-embed" className={'theme--' + theme}>
                    {/*<div className="debugging">{debugging}</div>*/}
                    <MyFriends
                      match={match}
                      device={device}
                      theme={theme}
                      version={version}
                      sessionId={sessionId}
                      accountId={accountId}
                      userName={userName}
                      userNameDisplay={userNameDisplay}
                      userAvatar={userAvatar}
                    />
                    {consoleLogViewer}
                  </div>
                )}
              />

              <Route
                exact
                path={config.baseUrl + '/recipes/:recipeId'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div id="app-container" className={'theme--' + theme}>
                      <div id="app-tools">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        <nav className="panel-toolbar">
                          <ul>
                            <li>
                              <ToolbarBackButton />
                            </li>
                          </ul>
                        </nav>
                        <Recipe
                          recipe={this.getRecipeEmbedded(match.params.recipeId)}
                        />
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />

              <Route
                path={config.baseUrl + '/' + userName + '/cookbooks'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div id="app-container" className={'theme--' + theme}>
                      <div id="app-tools">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        <MyLibrary
                          match={match}
                          sessionId={sessionId}
                          theme={theme}
                        />
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />
              <Route
                path={config.baseUrl + '/:userName/cookbooks'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div
                      id="app-container--published-recipes"
                      className={'theme--' + theme}
                    >
                      <div id="app-tools--published-recipes">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        <PublishedRecipes
                          match={match}
                          theme={theme}
                          userName={match.params.userName}
                          userLoggedIn={userLoggedIn}
                        />
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />
              <Route
                exact
                path={config.baseUrl + '/:userName'}
                render={({ match }) => (
                  <Redirect
                    to={
                      config.baseUrl +
                      '/' +
                      match.params.userName +
                      '/cookbooks'
                    }
                  />
                )}
              />

              <Route
                path={config.baseUrl + '/' + userName + '/friends'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div id="app-container" className={'theme--' + theme}>
                      <div id="app-tools">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        {/*<div className="debugging">{debugging}</div>*/}
                        <MyFriends
                          match={match}
                          device={device}
                          theme={theme}
                          sessionId={sessionId}
                          accountId={accountId}
                          userName={userName}
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                        />
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />
              <Route
                exact
                path={config.baseUrl + '/:userName/friends*'}
                render={({ match }) => (
                  <Redirect
                    to={
                      config.baseUrl +
                      '/' +
                      match.params.userName +
                      '/cookbooks'
                    }
                  />
                )}
              />

              <Route
                exact
                path={config.baseUrl + '/:userName/settings2'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div id="app-container" className={'theme--' + theme}>
                      <div id="app-tools">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        <nav className="panel-toolbar">
                          <ul>
                            <li>
                              <ToolbarBackButton />
                            </li>
                          </ul>
                        </nav>
                        <ul>
                          <li>
                            <p>Settings ...</p>
                          </li>
                        </ul>
                        {/*<Recipe*/}
                        {/*  recipe={this.getRecipeEmbedded(match.params.recipeId)}*/}
                        {/*/>*/}
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />

              <Route
                path={config.baseUrl + '/' + userName + '/settings'}
                render={({ match }) => (
                  <ScrollHandler>
                    <div id="app-container" className={'theme--' + theme}>
                      <div id="app-tools">
                        <AppLogo />
                        <UserArea
                          userNameDisplay={userNameDisplay}
                          userAvatar={userAvatar}
                          logout={this.logout}
                        />
                        <AppMenu userName={userName} logout={this.logout} />
                      </div>
                      <main>
                        <Settings
                          match={match}
                          sessionId={sessionId}
                          accountId={accountId}
                          theme={theme}
                        />
                      </main>
                    </div>
                  </ScrollHandler>
                )}
              />

            </Switch>
          </Router>
        </MuiThemeProvider>
      )
    }
  }
}

export default withStyles(config.loginStyles)(App)



// WEBPACK FOOTER //
// ./src/App.js